import type { ComponentProps } from 'react';

const CrossIcon = (props: ComponentProps<'svg'>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    {...props}
  >
    <path
      fill="#55657D"
      fillRule="evenodd"
      d="M2.707 1.293 2 .586.586 2l.707.707L8.586 10l-7.293 7.293L.586 18 2 19.414l.707-.707L10 11.414l7.293 7.293.707.707L19.414 18l-.707-.707L11.414 10l7.293-7.293.707-.707L18 .586l-.707.707L10 8.586 2.707 1.293Z"
      clipRule="evenodd"
    />
  </svg>
);

export default CrossIcon;
